function menuObserver(items) {
	//console.log(items, 'items');

	var el = items[0];

	if (el.isIntersecting) {
		menuActive(el.target.dataset.menuSection);
	} else {
		menuDeactive(el.target.dataset.menuSection);
	}

}

var activeClass = 'whitepaper-single__sidebar-list-item--active';

function menuActive(slug) {
	var els = document.querySelectorAll('.whitepaper-single__sidebar-list a[href=\'#' + slug + '\']');

	els.forEach(function (el) {

		$('.whitepaper-single__sidebar-list li').removeClass(activeClass);
		$(el).parents('li').addClass(activeClass);
	});
}

function menuDeactive(slug) {
	var els = document.querySelectorAll('.whitepaper-single__sidebar-list a[href=\'#' + slug + '\']');
	els.forEach(function (el) {
		el.classList.remove('active');
	});
}


function observerWhitePaperSideBar() {

	var menuOptions = {
		///rootMargin: "-100px 0px",
		//threshold : [0 , 0.5, 0.8]
	};


	var observer = new IntersectionObserver(menuObserver, menuOptions);

	var menuSections = document.querySelectorAll('.menu-observe');

	menuSections.forEach(function (item) {
		observer.observe(item);
	});

	$('.whitepaper-single__sidebar-list-item a').click(function () {

		var linkSlug = $(this).attr('href');
		window.setTimeout(function () {
			menuActive(linkSlug.slice(1));
		}, 300);
	});
}

jQuery(document).ready(function ($) {

	function handleWhitepaperTOC() {
		var whitepaperClass = 'ul.whitepaper-single__sidebar-list li.whitepaper-single__sidebar-list-item';

		// Re calculate waypoint positions.
		$('img').on('load', function () {
			Waypoint.refreshAll();
		});

		$('.whitepaper-single__sidebar-list-item a').click(function () {
			var sectionId = $(this).data('toc-index');

			// Close mobile TOC.
			$(this).toggleClass('is-active');
			$('.whitepaper-single__sidebar-list').toggleClass('is-active');
			$('.whitepaper-single__sidebar-divider').toggleClass('is-active');

			window.setTimeout(function () {
				$(whitepaperClass).removeClass(activeClass);
				$(whitepaperClass + '[data-toc-index="' + sectionId + '"]').addClass(activeClass);
			}, 250);
		});

		// Toggle the sidebar TOC.
		$('.js-trigger-whitepaper-toc').click(function (e) {
			e.preventDefault();

			$(this).toggleClass('is-active');
			$('.whitepaper-single__sidebar-list, .whitepaper-single__sidebar-divider').toggleClass('is-active');
		});

		/* // Register our waypoints.
		 document
			 .querySelectorAll('.whitepaper-single__section')
			 .forEach(function (section) {
				 // eslint-disable-next-line
				 var waypoint = new Waypoint({
					 element: section,
					 offset: '25%',
					 handler: function() {
						 var sectionId = $(section).data('toc-index');

						 $(whitepaperClass).removeClass(activeClass);
						 $(whitepaperClass +'[data-toc-index="' + sectionId + '"]').addClass(activeClass);
					 }
				 })
		 });*/

	}

	if ($('body').hasClass('single-whitepaper') || $('body').hasClass('page-template-page-whitepaper-with-toc')) {
		handleWhitepaperTOC();
		observerWhitePaperSideBar();
	}
});
